<template>
  <div>

    <div :class="[ {'no-handle':callStarted?callstatus!=2:false},{disabled:confirm}]">
      <div v-if="!newNote">
        <p
          class="btn-wrap"
          v-if="isAddedClue == 1"
        >
          <span
            :class="['btn',{'btn-disabled':callStarted?callstatus!=2:false}]"
            @click="addNewTrailNote()"
          >
            <i class="el-icon-plus"></i> 新增写跟进</span>
        </p>
      </div>
      <transition>
        <div v-show="!loading" >
          <div
            v-if="newNote"
            class="item"
            :class="{'hq-item':HQ}"
          >
            <p class="time">{{initDate|dateFormat('yyyy-MM-dd hh:mm')}}</p>
            <div class="content">
              <el-input
                type="textarea"
                id="addNote"
                autosize
                placeholder="写跟进..."
                v-model.trim="text"
                maxlength="500"
              >
              </el-input>
            </div>
            <div class="handle">
              <p class="handle-2">
                <span>
                  <span
                    :class="['save',{'hq-save':HQ},{disabled: disabledBtn}]"
                    @click="addTrailNote({text:text,action:0},text=='')"
                  >保存</span>
                  <span @click="newNote=false;text='';disabledBtn=false">取消</span>
                </span>
                <span class="count">
                  <span :style="{color:text.length>0?HQ?'#337ab7':'var(--theme-color)':'#999'}">{{text.length}}</span>/500</span>
              </p>
            </div>
          </div>
          <div class="list">
            <ul>
              <li
                v-for="(item,index) in newNoteList.item"
                :key="index"
                :class="['item',{'hq-item':HQ,connect:item.action==2&&item.duration>0,'hq-connect':item.action==2&&item.duration>0&&HQ,'no-connect':item.action==2&&!item.duration,'hq-no-connect':item.action==2&&!item.duration&&HQ}]"
              >
                <p class="time">{{item.createTime|dateFormat('yyyy-MM-dd hh:mm')}}</p>
                <p
                  class="title"
                  v-if="item.action!=0"
                >
                  <template v-if="item.action==1"><span class="normal">{{item.createUserName}}</span> 添加线索
                  </template>
                  <template v-if="item.action==2">
                    【呼出-
                    <span :style="{color:item.duration>0?HQ?'#337ab7':'var(--theme-color)':!item.duration&&item.duration!=0?HQ?'#337ab7':'var(--theme-color)':'var(--warning-color)'}">{{item.duration>0?'已接通':!item.duration&&item.duration!=0?'记录生成中':'未接通'}}</span>】
                    <el-tooltip
                      effect="dark"
                      :content="item.contact"
                      placement="bottom"
                      :disabled="item.contact&&item.contact.length<5"
                    >
                      <span>{{item.contact&&item.contact.length>4?item.contact.substring(0,4)+'...':item.contact?item.contact:'-'}}</span>
                    </el-tooltip> {{item.phoneNumber}}
                  </template>
                  <template v-if="item.action==4">
                    <span class="normal">{{item.transferBy.username}}</span> 将 <span class="normal">{{item.transferFrom.username}}</span>的线索【转移】给<span class="normal">{{item.transferTo.username}}</span>
                    <!-- <span :style="{color:item.duration>0?HQ?'#337ab7':'var(--theme-color)':!item.duration&&item.duration!=0?HQ?'#337ab7':'var(--theme-color)':'var(--warning-color)'}">{{item.duration>0?'已接通':!item.duration&&item.duration!=0?'记录生成中':'未接通'}}</span>】
                <el-tooltip effect="dark" :content="item.contact" placement="bottom" :disabled="item.contact&&item.contact.length<5">
                  <span>{{item.contact&&item.contact.length>4?item.contact.substring(0,4)+'...':item.contact?item.contact:'-'}}</span>
                </el-tooltip> {{item.phoneNumber}} -->
                  </template>
                </p>
                <template v-if="item.action!=1&&item.action!=4">
                  <aplayer
                    v-if="item.duration>0&&item.recordName&&(isAddedClue == 1||isAddedClue == 2&&role=='mainaccount')"
                    ref="aplayer"
                    :autoplay='false'
                    :mini="true"
                    :disabled="callStarted?callstatus!=2:false"
                    :music="{title: '',artist: '',src:item.recordName}"
                    style="margin-top:5px;border-top:1px solid #ecf2f5;"
                  />
                  <div class="content">
                    <p v-if="!(editStatus&&activeIndex===index)">{{(!item.full&&item.noteText.length>150)?item.noteText.substring(0,150)+'...':item.noteText}}
                      <span
                        v-if="item.noteText.length>150"
                        @click="item.full=!item.full"
                      >{{item.full?'收起':'全文'}}</span>
                    </p>
                    <el-input
                      v-else
                      type="textarea"
                      autosize
                      placeholder="写跟进..."
                      v-model.trim="item.noteText"
                      maxlength="500"
                    >
                    </el-input>
                  </div>
                  <!-- <aplayer  ref="aplayer" :autoplay='false' :mini="true" :disabled="callStarted?callstatus!=2:false" :music="{title: '',artist: '',src:'http://112.65.118.9/mp3.9ku.com/m4a/186947.m4a'}" style="border-top:1px solid #ecf2f5;padding-bottom:20px;" /> -->
                  <div
                    class="handle"
                    v-if="isAddedClue == 1"
                  >
                    <p
                      class="handle-2"
                      v-if="editStatus&&activeIndex===index"
                    >
                      <span>
                        <span
                          class="save"
                          :class="{'hq-save':HQ}"
                          @click="handleEdit('保存',item,index)"
                        >保存</span>
                        <span @click="handleCancelEdit('取消',item,index)">取消</span>
                      </span>
                      <span class="count">
                        <span :style="{color:item.noteText.length>0?HQ?'#337ab7':'var(--theme-color)':'#999'}">{{item.noteText.length}}</span>/500</span>
                    </p>
                    <div
                      class="handle-1"
                      v-else
                    >
                      <p :class="['record-user',{'record-user-absolute':user.username==item.createUserName}]">跟进人：<span>{{item.createUserName}}</span></p>
                      <template v-if="user.userid==item.createUserId">
                        <span
                          :style="{color:HQ?'#e15151':'var(--theme-color)'}"
                          @click="handleEdit('编辑',item,index)"
                        >编辑</span>
                        <span
                          class="line"
                          v-if="!('addEdit' in item)||('addEdit' in item)&&item.addEdit"
                        >|</span>
                        <span
                          @click="handleCancelEdit('删除',item,index)"
                          v-if="!('addEdit' in item)||('addEdit' in item)&&item.addEdit"
                        >删除</span>
                      </template>
                    </div>
                  </div>
                  <div
                    class="handle"
                    v-else
                  >
                    <div class="handle-1">
                      <p :class="['record-user']">跟进人：<span>{{item.createUserName}}</span></p>
                    </div>
                  </div>
                </template>
              </li>
            </ul>
          </div>
          <div
            class="load-more"
            v-show="loadingMore"
          >
            <!-- <div class="load-more" v-show="true"> -->
            <span>正在加载更多</span>
          </div>
        </div>
      </transition>
  </div>
  </div>

</template>
<script>
// import Aplayer from 'vue-aplayer'

import Aplayer from "../aplayer/vue-aplayer.vue";
import filters from "../../filter/index.js";
import debounce from "lodash/debounce";
import { mapState } from "vuex";
import { eventHub } from "../../common/utils.js";
// new Vue({

// })

export default {
  props: ["disabled","confirm"],
  components: {
    Aplayer
  },
  data() {
    return {
      dialogVisible: true,
      // id: this.$router.currentRoute.params.id,
      text: "",
      cid: "",
      action: 0,
      isAdding: false,
      initDate: null,
      newNote: false,
      newNoteList: {
        total: 0,
        item: []
      },
      music: {
        title: "",
        artist: "",
        src: ""
      },
      oldEdit: null,
      activeIndex: null,
      deleteIndex: null,
      deleteNoteId: null,
      editStatus: false,
      page: 1,
      loadingMore: false,
      loadMore: true,
      loading: false,
      disabledBtn: false,
      callstatus: 0,
      errorDivert:false
    };
  },
  computed: {
    ...mapState({
      user: state => state.account.baseInfo,
      id: state => state.callInfo.reportObj.id,
      callStatus: state => state.callInfo.callStatus,
      callStarted: state => state.callInfo.callStarted,
      isAddedClue: state => state.callInfo.reportObj.isAddedClue
    })
  },
  mounted() {
    this.getTrailNoteList();
    eventHub.$on("refreshTrailNoteList",this.getTrailNoteList);
    eventHub.$on("callstatus",this.handCallstatus);
    // eventHub.$on("addTrailNote", this.addTrailNote);
  },
  watch: {
    callstatus(val,oldVal) {
      /* 重播刷新、挂断刷新 */
      if((oldVal==2&&val==0)||val==2) {
        this.getTrailNoteList(1);
      }
      if(this.callStarted&&val===0) {
        this.destroyedSave('create');
      }
      if(val===1) {
        // eventHub.$meit("quickQause");
        eventHub.$emit("quickQause");
      }
    },
    callStarted(val) {
      if(val) {
        this.destroyedSave('create');
      }
    },
    id(val) {
      if(val) {
        this.page=1
        this.getTrailNoteList();
      }
    }
  },

  created() {
    const _self=this;
    _self.$nextTick(() => {
      let wrap=document.querySelector(".drag-main.el-scrollbar__wrap");
      wrap.addEventListener("scroll",_self.scrollHandler);
    });
  },
  beforeDestroy() {
    const _self=this;
    _self.$nextTick(() => {
      let wrap=document.querySelector(".drag-main.el-scrollbar__wrap");
      wrap.removeEventListener("scroll",_self.scrollHandler);
    });
    _self.destroyedSave();
  },
  methods: {
    destroyedSave(type) {
      if(this.editStatus&&this.activeIndex!=null&&this.newNoteList.item[this.activeIndex].noteText!="") {
        this.editTrailNote(type);
      } else if(this.newNote&&!this.editStatus&&this.text) {
        this.addTrailNote({ text: this.text,action: 0 });
      }
    },
    handCallstatus(val) {
      this.callstatus=val;
    },
    scrollHandler: debounce(function() {
      let wrap=document.querySelector(".drag-main.el-scrollbar__wrap");
      let content=document.querySelector(".drag-main .el-scrollbar__view");
      let scrollTop=wrap.scrollTop;
      let wrapHeight=wrap.offsetHeight;
      let contentHeight=content.offsetHeight;
      let heightDiff=contentHeight-wrapHeight;
      if(scrollTop>=heightDiff-20&&this.loadMore&&!this.confirm) {
        this.getTrailNoteList();
      }
    },100),
    handleEdit(type,item,index) {
      if(this.callStarted&&this.callstatus!=2) {
        return;
      }
      /* 我的线索修改线索后刷新列表 */
      if(type=="编辑"&&this.$route.path=='/pool') {
        this.$store.commit("setCloseCard",false);
      }
      /* 点击编辑时保存其他输入框的内容 */
      if(type=="编辑"&&!this.text) {
        this.newNote=false;
        this.disabledBtn=false;
        // console.log("点击编辑时保存其他输入框的内容");
      }
      /* 点击编辑时保存其他输入框的内容 */
      if(
        type=="编辑"&&
        this.editStatus&&
        this.activeIndex!=null&&
        this.activeIndex!=index&&
        this.newNoteList.item[this.activeIndex].noteText!=""
      ) {
        this.editTrailNote();
        // console.log("点击编辑时保存其他输入框的内容");
      }
      /* 第一次编辑通话的跟进离开未保存时 */
      if(
        type=="编辑"&&
        this.activeIndex!=null&&
        "addEdit" in this.newNoteList.item[this.activeIndex]&&
        this.newNoteList.item[this.activeIndex].noteText==""
      ) {
        this.newNoteList.item[this.activeIndex].addEdit=false;
      }
      this.oldEdit=item.noteText;
      this.editStatus=true;
      this.activeIndex=index;
      if(type=="保存") {
        this.disabledBtn=true;
        this.editTrailNote("hint");
      }
    },
    handleCancelEdit(type,item,index) {
      if(this.callStarted&&this.callstatus!=2) {
        return;
      }
      /* 我的线索修改线索后刷新列表 */
      if(type=="删除"&&this.$route.path=='/pool') {
        this.$store.commit("setCloseCard",false);
      }
      if(type=="取消") {
        this.$set(this.newNoteList.item[index],"noteText",this.oldEdit);
        this.editStatus=false;
        this.activeIndex=null;
        // this.newNote = false;
      } else {
        this.$emit("isConfirm",true);
        this.deleteIndex=index;
        this.deleteNoteId=item.noteId;
        // this.confirmDeleteTrailNote()
      }
    },

    addNewTrailNote() {
      if(this.callStarted&&this.callstatus!=2) {
        return;
      }
      if(
        this.editStatus&&
        this.activeIndex!=null&&
        this.newNoteList.item[this.activeIndex].noteText!=""
      ) {
        this.editTrailNote("create");
      }
      this.initDate=new Date();
      this.newNote=true;
      /* 我的线索修改线索后刷新列表 */
      if(this.$route.path=='/pool') {
        this.$store.commit("setCloseCard",false);
      }
      /* 新增获取输入框焦点 */
      this.$nextTick(function() {
        const addNote=document.getElementById('addNote');
        addNote.focus()
      })
    },
    handleCallTrailNote(event,item,index,type) {
      if(type=="add") {
        this.$set(this.newNoteList.item[index],"addEdit",true);
        this.activeIndex=index;
        this.editStatus=true;
      } else {
        this.activeIndex=null;
        this.editStatus=false;
        this.$set(this.newNoteList.item[index],"addEdit",false);
      }
    },

    async editTrailNote(type) {
      try {
        const data={
          noteId: this.newNoteList.item[this.activeIndex].noteId,
          noteText: this.newNoteList.item[this.activeIndex].noteText
        };
        const result=await this.apiData("post","clue/editTrailNote",data);
        /* 我的线索修改线索后刷新列表 */
        if(this.$route.path=='/pool') {
          this.$store.commit("setCloseCard",true);
        }
        // this.$message.success("保存成功");
        if("addEdit" in this.newNoteList.item[this.activeIndex]) {
          delete this.newNoteList.item[this.activeIndex].addEdit;
          this.$set(this.newNoteList.item[this.activeIndex],"edit",true);
        }
        if(type=="create"||type=="hint") {
          this.editStatus=false;
          this.activeIndex=null;
        }
        this.disabledBtn=false;
        // this.newNote = false;
        // console.log("保存成功");
        type=="hint"? this.$message.success("保存成功"):"";
      } catch(error) {
        this.disabledBtn=false;
        this.$message.error(this.errorCode[error.error_code]);
      }
    },
    cancelConfirm() {
      this.deleteNoteId=null;
      this.deleteIndex=null;
    },
    async deleteTrailNote(data,index) {
      try {
        const result=await this.apiData("post","clue/deleteTrailNote",{
          noteId: this.deleteNoteId
        });
        this.$message.success("删除成功");
        /*    this.newNoteList.item.splice(index, 1);*/
        this.$emit("isConfirm",false);
        this.page=1;
        this.getTrailNoteList();
        /* 我的线索修改线索后刷新列表 */
        if(this.$route.path=='/pool') {
          this.$store.commit("setCloseCard",true);
        }
      } catch(error) {
        this.$emit("isConfirm",false);
        this.$message.error(this.errorCode[error.error_code]);
      }
    },
    async addTrailNote(data,close=false) {
      this.disabledBtn=true;
      if(close) {
        this.newNote=false;
        this.disabledBtn=false;
        return;
      }
      try {
        const params=Object.assign({ pid: this.id },data);
        const result=await this.apiData("post","clue/addTrailNote",params);
        /* 我的线索修改线索后刷新列表 */
        if(this.$route.path=='/pool') {
          this.$store.commit("setCloseCard",true);
        }
        this.newNote=false;
        this.disabledBtn=false;
        (this.activeIndex=null),(this.editStatus=false),(this.text="");
        this.$message.success("保存成功");
        this.page=1;
        this.getTrailNoteList();
      } catch(error) {
        this.disabledBtn=false;
        this.$message.error(this.errorCode[error.error_code]);
      }
    },

    getTrailNoteList: debounce(async function(page) {
      if(this.isAddedClue==0) {
        return
      }
      this.page=page? page:this.page;
      if(this.loadingMore&&this.page!=1) {
        return;
      }
      if(this.page==1) {
        this.loading=true;
      } else {
        this.loadingMore=true;
      }
      try {
        const result=await this.apiData("get","clue/getTrailNoteList",{
          pid: this.id,
          page: this.page
        });
        this.loadingMore=false;
        this.loading=false;
        if(result.item.length==0) {
          this.loadMore=false;
          return;
        }
        if(this.page>1) {
          const addNoteList=result.item.map(item => {
            item.edit=item.noteText!="";
            if(item.noteText=="") {
              item.addEdit=false;
            }
            item.full=false;
            return item;
          });
          this.newNoteList.item=[...this.newNoteList.item,...addNoteList];
        } else {
          let newResult=result.item.map(item => {
            item.edit=item.noteText!="";
            if(item.noteText=="") {
              item.addEdit=false;
            }
            item.full=false;
            return item;
          });
          this.newNoteList.item=[...newResult];
        }
        this.newNoteList.total=result.total;
        if(this.newNoteList.item.length===result.total) {
          this.loadMore=false;
        } else {
          this.loadMore=true;
        }
        this.page++;
      } catch(error) {
        this.loadingMore=false;
        this.$message.error(this.errorCode[error.error_code]);
        if(error.error_code== '6007'){
          eventHub.$emit('updateReport')
          eventHub.$emit('closeReportDialog')
        }
      }
    },200)
  }
};
</script>
<style lang="scss" scoped>
.btn-wrap {
  .btn {
    width: 100%;
    background-color: #ffffff;
    box-shadow: 0.7px 0.7px 10px 0 rgba(0, 0, 0, 0.1);
    text-align: center;
    line-height: 54px;
    color: #999;
    display: inline-block;
    cursor: pointer;
    border-radius: 2px;
    &.btn-disabled {
      color: #ccc;
      cursor: not-allowed;
    }
  }
}
.item {
  list-style: none;
  position: relative;
  margin-top: 20px;
  padding: 20px 0px 10px;
  box-shadow: 0.7px 0.7px 10px 0 rgba(0, 0, 0, 0.1);
  &.connect {
    &:before {
      background-color: #ffc836;
    }
  }
  &.no-connect {
    &:before {
      background-color: #f97a7d;
    }
  }
  &.hq-item {
    &:before {
      background-color: #337ab7;
    }
  }
  &.hq-connect {
    &:before {
      background-color: #ffc836;
    }
  }
  &.hq-no-connect {
    &:before {
      background-color: #e15151;
    }
  }
  &:before {
    content: "";
    display: block;
    position: absolute;
    width: 110px;
    height: 4px;
    left: 0;
    top: 0;
    background-color: var(--theme-color);
  }
  .time {
    color: #999;
    font-size: 14px;
    line-height: 20px;
    padding-left: 16px;
    padding-right: 16px;
  }
  .title {
    padding-left: 16px;
    padding-right: 16px;
    font-size: 14px;
    line-height: 30px;
    color: #2c353a;
    text-indent: -0.5em;
    .normal {
      margin-left: 5px;
      margin-right: 5px;
      color: #6c7980;
    }
  }
  .content {
    margin-top: 5px;
    margin-bottom: 10px;
    padding-left: 16px;
    padding-right: 16px;
    p {
      color: #555;
      font-size: 14px;
      line-height: 23px;
      word-break: break-all;
      span {
        color: var(--auxiliary-bg-color);
        cursor: pointer;
      }
    }
  }
  .handle {
    font-size: 14px;
    color: var(--text-auxiliary-color);
    span {
      display: inline-block;
      cursor: pointer;
    }
    .handle-1 {
      padding-left: 16px;
      padding-right: 16px;
      border-top: 1px solid rgba(0, 0, 0, 0.1);
      padding-top: 10px;
      text-align: right;
      position: relative;
      min-height: 16px;
      .record-user {
        text-align: left;
        color: #999;
        &.record-user-absolute {
          position: absolute;
          left: 16px;
        }
        span {
          color: #555;
          cursor: initial;
        }
      }
      .line {
        color: #f1f1f1;
        margin: 0 12px;
      }
    }
    .handle-2 {
      padding-right: 16px;
      display: flex;
      justify-content: space-between;
      // padding-top: 10px;
      padding-left: 25px;
      .save {
        padding: 10px;
        color: #fff;
        border-radius: 2px;
        background-color: var(--theme-color);
        margin-right: 19px;
        cursor: pointer;
        &.hq-save {
          background-color: #e15151;
          &:hover {
            background-color: #f75353;
          }
        }
      }

      .count {
        align-items: center;
        display: inherit;
        cursor: initial;
      }
    }
  }
}

.load-more {
  width: 110px;
  height: 32px;
  line-height: 32px;
  border-radius: 2px;
  background-color: #72848c;
  text-align: center;
  position: absolute;
  bottom: 15px;
  left: 50%;
  margin-left: -55px;
  span {
    font-size: 12px;
    color: #ffffff;
  }
}
.disabled {
  pointer-events: none;
}
.no-handle {
  .handle {
    span {
      cursor: not-allowed;
      color: var(--text-auxiliary-color) !important;
    }
  }
}
</style>
<style lang="scss">
.item {
  .el-textarea__inner {
    padding: 0;
    padding-bottom: 10px;
    border-top: none;
    border-left: none;
    border-right: none;
    resize: none;
    border-radius: none;
    &:focus {
      border-color: #dcdfe6;
    }
  }
}
.textarea-padd {
  .title {
    border-bottom: 1px solid #f1f1f1;
  }
  .el-textarea {
    .el-textarea__inner {
      padding-top: 60px;
    }
  }
}
.aplayer-module {
  width: 770px;
  .el-dialog__body {
    padding: 20px;
  }
  .el-dialog__header {
    background: var(--auxiliary-bg-color);
    .el-dialog__title {
      color: #fff;
      font-size: 16px;
    }
    .el-dialog__headerbtn {
      .el-dialog__close {
        color: #d3e1f1;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/report/thread.vue